module.exports = __webpack_public_path__ + "portal-static/img/管理员.8eeaf49a.png";